import axios from 'axios'
import { useEffect, useState } from 'react'

export const usePatients = () => {
    const [patients, setPatients] = useState([])
    // get patients
    const getPatients = async () => {
        try {
            const {data} = await axios.get('http://localhost:3000/patients')
            console.log('Data: ', data)
            setPatients(data)
        } catch (error) {
            console.log('Error: ', error)
        }   
    }
    useEffect(() => {
        getPatients()
    },[])
  return patients
}

